<template>
  <a :class="classStyle" :href="url">
    {{ label }}
  </a>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    block: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'primary',
    },
    button: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classStyle() {
      const { button, block, color } = this
      return [
        'v-link',
        button ? 'v-link--button' : null,
        block ? 'v-link--block' : null,
        `v-link--${color}`,
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.v-link {
  color: #666;
}

.v-link--button {
  padding: 12px 18px;
  background: #444;
  border: 0;
  color: #fff;
  font-size: 13px;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
  box-sizing: border-box;
  height: 44px;
  line-height: 24px;
}

.v-link--block {
  display: block;
  width: 100%;
  text-align: center;
}

.v-link--gray {
  background-color: #f2f2f6;
  color: #666;
  border-color: #f2f2f6;
}

.v-link:hover {
  opacity: 0.9;
}
</style>
